/**
 * API Configuration
 * Centralized API URL configuration used across the application
 */

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  SEARCH: '/search',
  MATCH_CLOTHING: '/api/match-clothing',
  SEARCH_BY_KEYWORD: '/api/search_by_keyword',
  TEST_RAKUTEN: '/api/affiliates/test-rakuten',
  COMPARE_AFFILIATES: '/api/affiliates/compare',
  DEALS_COUPONS: '/api/deals/coupons',
  DEALS_OFFERS: '/api/deals/offers',
  DEALS_MERCHANT_PRODUCTS: '/api/deals/merchant-products',
};

// Helper function to build full URL
export const buildApiUrl = (endpoint, params = {}) => {
  const url = new URL(endpoint, API_URL);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return url.toString();
};

export default API_URL;


